import React from 'react';
import { handleEnterPress } from '../../helpers/util';
import * as styles from './styles.module.scss';

interface Props {
  items?: {
    title: string;
    text?: string;
    value: any;
    icon?: JSX.Element;
  }[];
  className?: string;
  itemSelected: (value: any) => void;
  icon?: React.ElementType;
}

const ListSelect: React.FC<Props> = ({
  items = [],
  itemSelected,
  icon: Icon,
  className,
}) => {
  return (
    <ul className={[styles.list, className || ''].join(' ')}>
      {items.map((x, i) => {
        const { title, text, value } = x;

        let icon;

        if (x.icon) {
          icon = <div className={styles.icon}>{x.icon}</div>;
        } else if (Icon) {
          icon = (
            <div className={styles.icon}>
              <Icon />
            </div>
          );
        } else {
          icon = '';
        }

        const onClick = () => itemSelected(value);

        return (
          <li key={i}>
            <div
              className={styles.item}
              onClick={onClick}
              onKeyDown={handleEnterPress(onClick)}
              role='button'
              tabIndex={0}
            >
              {icon}
              <div className={styles.text_container}>
                <span className={styles.title}>{title}</span>
                <span className={styles.text}>{text}</span>
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default ListSelect;
